import { render, staticRenderFns } from "./LittleGateLockDamage.vue?vue&type=template&id=8f47cc4a&scoped=true"
import script from "./LittleGateLockDamage.vue?vue&type=script&lang=ts"
export * from "./LittleGateLockDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f47cc4a",
  null
  
)

export default component.exports